import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { Suggestion } from '../../store/types';
import { artifactFromWire } from '../../store/wire';
import PatchCard from './primitives/patch-card';
import SuggestionProse from './primitives/suggestion-prose';
type GhostArtifactProps = {
  suggestion: Suggestion;
};
const GhostArtifact = t0 => {
  const $ = _c(14);
  const {
    suggestion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.suggestion.artifact"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  if (suggestion.operation.kind !== "add_task_artifact") {
    return null;
  }
  let t2;
  if ($[1] !== suggestion.operation.artifact) {
    t2 = artifactFromWire(suggestion.operation.artifact);
    $[1] = suggestion.operation.artifact;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const artifact = t2;
  const t3 = suggestion.id;
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !suggestion.canApply;
  let t6;
  if ($[5] !== artifact.spec) {
    t6 = artifact.spec && <SuggestionProse>{artifact.spec}</SuggestionProse>;
    $[5] = artifact.spec;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== artifact.name || $[8] !== artifact.type || $[9] !== suggestion.id || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <PatchCard suggestionId={t3} note={t4} isStale={t5} title={artifact.name} subtype={artifact.type}>{t6}</PatchCard>;
    $[7] = artifact.name;
    $[8] = artifact.type;
    $[9] = suggestion.id;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default GhostArtifact;
function _temp($) {
  return $.add;
}